import { markRaw, defineAsyncComponent } from 'vue';
import type { DiscoveredRouteModule } from '@/router/generator/types';
import { eventEditGuard } from '@/router/guards/eventEditGuard';

// Components
const PortalEventsIndexView = () => import('@/views/portal/events/IndexView.vue');
const PortalEventsEditView = () => import('@/views/portal/events/EditView.vue');
const PortalEventsViewView = () => import('@/views/portal/events/ViewView.vue');
const PortalEventsAdminView = () => import('@/views/portal/events/AdminView.vue');
const PortalEventsView = () => import('@/views/portal/EventsView.vue');

// Header components used via meta.dynamicComponent
const PortalEventsIndexHeaderComponent = defineAsyncComponent(() => import('@/components/app/portal/events/header-components/IndexHeader.vue'));
const PortalEventsEditHeaderComponent = defineAsyncComponent(() => import('@/components/app/portal/events/header-components/EditHeader.vue'));
const PortalEventsViewHeaderComponent = defineAsyncComponent(() => import('@/components/app/portal/events/header-components/ViewHeader.vue'));
const PortalEventsAdminHeaderComponent = defineAsyncComponent(() => import('@/components/app/portal/events/header-components/AdminHeader.vue'));

// Names and path
export const NAME_PORTAL_EVENTS = 'PortalEvents';
export const NAME_PORTAL_EVENTS_INDEX = 'PortalEventsIndex';
export const NAME_PORTAL_EVENTS_EDIT = 'PortalEventsEdit';
export const NAME_PORTAL_EVENTS_VIEW = 'PortalEventsView';
export const NAME_PORTAL_EVENTS_ADMIN = 'PortalEventsAdmin';
export const PATH_PORTAL_EVENTS = 'portal/events';

export const route: DiscoveredRouteModule = {
  id: 'app.portal.events',
  scope: 'app',
  moduleKey: 'events',
  name: NAME_PORTAL_EVENTS,
  path: PATH_PORTAL_EVENTS,
  component: PortalEventsView,
  redirect: { name: NAME_PORTAL_EVENTS_INDEX },
  children: [
    {
      path: '',
      component: PortalEventsIndexView,
      name: NAME_PORTAL_EVENTS_INDEX,
      meta: {
        dynamicComponent: markRaw(PortalEventsIndexHeaderComponent),
        dynamicComponentScale: 'scale-75',
        dataLoaders: ['project_events', 'algolia', 'project_user_fields', 'portal_base']
      }
    },
    {
      path: ':id/edit',
      component: PortalEventsEditView,
      name: NAME_PORTAL_EVENTS_EDIT,
      beforeEnter: eventEditGuard,
      meta: {
        dynamicComponent: markRaw(PortalEventsEditHeaderComponent),
        dynamicComponentScale: 'scale-75',
        dataLoaders: ['project_events', 'project_channels', 'active_project_event', 'algolia', 'project_user_fields', 'portal_base']
      }
    },
    {
      path: ':id/view',
      component: PortalEventsViewView,
      name: NAME_PORTAL_EVENTS_VIEW,
      meta: {
        dynamicComponent: markRaw(PortalEventsViewHeaderComponent),
        dynamicComponentScale: 'scale-75',
        dataLoaders: ['project_events', 'active_project_event', 'algolia', 'project_user_fields', 'portal_base']
      }
    },
    {
      path: ':id/admin',
      component: PortalEventsAdminView,
      name: NAME_PORTAL_EVENTS_ADMIN,
      meta: {
        dynamicComponent: markRaw(PortalEventsAdminHeaderComponent),
        dynamicComponentScale: 'scale-75',
        requiresAdmin: true,
        allowedRoles: ['admin'],
        dataLoaders: ['project_events', 'active_project_event', 'algolia', 'project_user_fields', 'portal_base']
      }
    }
  ],
  meta: {
    requiresFeature: 'events'
  }
};


